import jsonata from 'jsonata/jsonata-es5'
import { uniq, uniqBy } from 'lodash'

const wrappedJsonata = (...args) => {
  const expression = jsonata(...args)
  // See documentation on registering functions:
  // http://docs.jsonata.org/embedding-extending#expressionregisterfunctionname-implementation-signature

  // <a-:a> means 1st param is array (or use context, that's the dash after the 'a'), return an array
  expression.registerFunction('uniq', uniq, '<a-:a>')
  // <a-(fs):a> means 1st para is array, 2nd param is function or string, return array
  expression.registerFunction('uniqBy', uniqBy, '<a-(fs):a>')

  return expression
}

export default wrappedJsonata
